import axios from "axios"

export async function AxiosPut(jwt, fullEndpointURL, data) {
  const axiosObj = axios.create()

  const requestConfig = {
    headers: {
      Authorization: "Bearer " + jwt,
      "Content-Type": "application/json",
    },
  }

  const result = await axiosObj
    .put(fullEndpointURL, data, requestConfig)
    .then((responseBody) => {
      return responseBody.data
    })

  return result
}

export async function AxiosPost(jwt, fullEndpointURL, data, contentType) {
  const axiosObj = axios.create()

  const requestConfig = {
    headers: {
      Authorization: "Bearer " + jwt,
      "Content-Type": contentType || "application/json",
    },
  }

  const result = await axiosObj
    .post(fullEndpointURL, data, requestConfig)
    .then((responseBody) => {
      return responseBody.data
    })

  return result
}

export async function AxiosGet(jwt, fullEndpointURL) {
  const axiosObj = axios.create()

  const requestConfig = {
    headers: {
      Authorization: "Bearer " + jwt,
    },
  }

  const result = await axiosObj
    .get(fullEndpointURL, requestConfig)
    .then((responseBody) => {
      return responseBody.data
    })

  return result
}

export async function AxiosDelete(jwt, fullEndpointURL) {
  const axiosObj = axios.create()

  const requestConfig = {
    headers: {
      Authorization: "Bearer " + jwt,
    },
  }

  const result = await axiosObj
    .delete(fullEndpointURL, requestConfig)
    .then((responseBody) => {
      return responseBody.data
    })

  return result
}
